import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-instagram-icon',
  templateUrl: 'instagram-icon.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class InstagramIconComponent {
}

